// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__3REQV","content":"SubHeader_content__DuaAt","btnBack":"SubHeader_btnBack__2Toz7","line":"SubHeader_line__nVMnU"};